import curry from 'lodash/curry';
import createApiRequest from '@/lib/axios/createApiRequest';
import joinNonEmptyParams from '@/utils/joinNonEmptyParams';

const fetchContribution = (donationId: string) => {
  // eslint-disable-next-line no-console
  console.warn('fetchContribution to be implemented', donationId);

  return {};
};

// TODO: add type for contribution form data when time permits
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const createContribution = (data: any) =>
  createApiRequest({
    data,
    method: 'post',
    path: 'donations',
    throwErrors: true,
  });

const deleteContribution = (donationId: string) =>
  createApiRequest({
    method: 'delete',
    path: `donations/${donationId}`,
  });

export const pledgeReconcile = (
  method: ApiMethod,
  ownerOrgId: string,
  pledgeDonationId: string,
  donationId: string,
  throwErrors: boolean,
) =>
  createApiRequest({
    method,
    path: `donations/pledge-reconcile?${joinNonEmptyParams({
      ownerOrgId,
      pledgeDonationId,
      donationId,
    })}`,
    throwErrors,
  });

export const linkDonationToPledge = curry(pledgeReconcile)('post');
export const unlinkDonationFromPledge = curry(pledgeReconcile)('delete');

export const contributionsService = {
  fetchContribution,
  createContribution,
  deleteContribution,
  linkDonationToPledge,
  unlinkDonationFromPledge,
};
